// extracted by mini-css-extract-plugin
module.exports = {"container":"Review_container__1OxX2","heading":"Review_heading__3bYLY","description":"Review_description__2zLA3","review":"Review_review__1XvGP","tweet":"Review_tweet__1eeCn"};